import { Card, Typography, theme, Flex, Space } from "antd"
import { Icon } from "ui/Icon"
import PropTypes from "prop-types"
import logo from "assets/images/logo.jpg"
import { getStyles } from "./styles"

const { Text } = Typography
const { useToken } = theme

export const ResourceCard = ({ name, type, selected, onEdit, onSelect, properties = [] }) => {
  const { token } = useToken()
  const styles = getStyles(selected, token)
  const firstImage = properties?.[0]?.url

  const handleEditClick = (e) => {
    e.stopPropagation()
    onEdit?.()
  }

  return (
    <Card onClick={onSelect} className="cursor-pointer" styles={{ body: styles.cardBody }} style={styles.card}>
      <Flex align="center" gap="middle">
        <div style={styles.imageContainer}>
          {firstImage ? (
            <img src={firstImage} alt={name} style={styles.image} />
          ) : (
            <img src={logo} alt="Default logo" style={styles.defaultImage} />
          )}
        </div>

        <div className="flex-grow-1">
          <Text strong className="d-block">
            {name}
          </Text>
          <Text type="secondary">{type}</Text>
        </div>

        <Space size="middle">
          <div onClick={handleEditClick} style={styles.editButton}>
            <Icon type="feather" name="Edit" width={16} height={16} color="currentColor" className="text-secondary" />
          </div>

          <div style={styles.checkbox}>{selected && <Icon type="feather" name="Check" width={14} height={14} color="white" />}</div>
        </Space>
      </Flex>
    </Card>
  )
}

ResourceCard.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onEdit: PropTypes.func,
  onSelect: PropTypes.func,
  properties: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string
    })
  )
}
